export class WhereElephantCpa {

    constructor() {
        this.init();
    }

    init() {
        window.gdeslon_q = window.gdeslon_q || [];
        return window.gdeslon_q;
    }


    push(params = {}) {
        params.merchant_id = 93424;
        window.gdeslon_q.push(params);
    }


    indexPageView(data = {}) {
        this.push({
            'page_type': 'main',
            'user_id': data.user.email
        });
    }

    categoryPageView(data = {}) {
        let productResult = [];
        let products = data.products;
        let count = products.length;
        for (let i = 0; i < count; i++) {
            let product = products[i];
            let params = {};
            params.id = parseInt(product.id);
            params.price = product.price;
            params.quantity = 1;
            productResult.push(params);
        }

        this.push({
            'page_type': 'list',
            'user_id': data.user.email,
            'category_id': data.category.id,
            'products': productResult
        });
    }

    productPageView(data = {}) {
        this.push({
            'page_type': 'card',
            'user_id': data.user.email,
        });
    }

    basketPageView(data = {}) {
        this.push({
            'page_type': 'basket',
            'user_id': data.user.email,
            'products': data.basket
        });
    }

    otherPageView(data) {
        this.push({
            'page_type': 'basket',
            'user_id': data.user.email,
        });
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/where-elephant-cpa.js